export const BREEDER_JOIN_TITLE = 'Join our Good Breeder community';
export const BREEDER_JOIN_BODY =
  "Are you a responsible breeder? We'd love to recognize you. Connect directly with informed buyers, get access to free benefits, and more.";
